import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ApiError } from "../lib/api";
import { useAuth } from "../lib/auth";
export default function LoginPage() {
    const { me, loading, needsBootstrap, login, register } = useAuth();
    const navigate = useNavigate();
    const mode = needsBootstrap ? "register" : "login";
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [fullName, setFullName] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState(null);
    if (loading)
        return null;
    if (me)
        return _jsx(Navigate, { to: "/app", replace: true });
    async function submit(e) {
        e.preventDefault();
        setErr(null);
        setBusy(true);
        try {
            if (mode === "register") {
                await register(email, password, fullName || undefined);
            }
            else {
                await login(email, password);
            }
            navigate("/app");
        }
        catch (e) {
            if (e instanceof ApiError)
                setErr(e.message);
            else
                setErr("unexpected error");
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsx("div", { className: "flex min-h-full items-center justify-center px-6 py-12", children: _jsxs("div", { className: "w-full max-w-sm", children: [_jsx("h1", { className: "mb-1 text-2xl font-semibold tracking-tight text-ink-50", children: mode === "register" ? "Create the first administrator" : "Sign in to AutoVal" }), _jsx("p", { className: "mb-8 text-sm text-ink-400", children: mode === "register"
                        ? "Bootstrap your workspace by creating the initial superuser account."
                        : "Use the credentials issued by your administrator." }), _jsxs("form", { onSubmit: submit, className: "space-y-4", children: [mode === "register" && (_jsx(Field, { label: "Full name (optional)", children: _jsx("input", { className: "input", value: fullName, onChange: (e) => setFullName(e.target.value), autoComplete: "name" }) })), _jsx(Field, { label: "Email", children: _jsx("input", { className: "input", type: "email", required: true, value: email, onChange: (e) => setEmail(e.target.value), autoComplete: "email" }) }), _jsx(Field, { label: "Password", children: _jsx("input", { className: "input", type: "password", required: true, minLength: mode === "register" ? 10 : 1, value: password, onChange: (e) => setPassword(e.target.value), autoComplete: mode === "register" ? "new-password" : "current-password" }) }), err && (_jsx("p", { className: "rounded-md border border-red-700/50 bg-red-900/20 p-3 text-sm text-red-200", children: err })), _jsx("button", { className: "btn-primary w-full", disabled: busy, children: busy ? "…" : mode === "register" ? "Create administrator" : "Sign in" })] }), !needsBootstrap && (_jsx("p", { className: "mt-8 text-center text-xs text-ink-500", children: "New users are created by an administrator from inside the platform." }))] }) }));
}
function Field({ label, children }) {
    return (_jsxs("label", { className: "block", children: [_jsx("span", { className: "mb-1 block text-xs uppercase tracking-wide text-ink-400", children: label }), children] }));
}
